import React from 'react';
import { Box } from '@mui/material';
import { useThemeContext } from '../context/ThemeContext';

interface SpiderLogoProps {
  onClick?: () => void;
}

const SpiderLogo: React.FC<SpiderLogoProps> = ({ onClick }) => {
  const { darkMode } = useThemeContext();
  const logoSrc = require(`../media/${darkMode ? 'black' : 'white'}-spider.png`);

  return (
    <Box onClick={onClick} sx={{ cursor: 'pointer', display: 'flex' }}>
      <img src={logoSrc} alt="Logo" style={{ height: 50, width: 'auto' }} />
    </Box>
  );
};
export default SpiderLogo;